import React from "react";

import styles from "./Colors.module.scss";
import { ColorSwatch } from "../ColorSwatch/ColorSwatch";

export function FoundationColors() {
  const colorSections = [
    {
      title: "Neutrals",
      colors: [
        { name: "Neutral 0", var: "--foundation-neutral-0" },
        { name: "Neutral 50", var: "--foundation-neutral-50" },
        { name: "Neutral 100", var: "--foundation-neutral-100" },
        { name: "Neutral 150", var: "--foundation-neutral-150" },
        { name: "Neutral 200", var: "--foundation-neutral-200" },
        { name: "Neutral 250", var: "--foundation-neutral-250" },
        { name: "Neutral 300", var: "--foundation-neutral-300" },
        { name: "Neutral 350", var: "--foundation-neutral-350" },
        { name: "Neutral 400", var: "--foundation-neutral-400" },
        { name: "Neutral 450", var: "--foundation-neutral-450" },
        { name: "Neutral 500", var: "--foundation-neutral-500" },
        { name: "Neutral 550", var: "--foundation-neutral-550" },
        { name: "Neutral 600", var: "--foundation-neutral-600" },
        { name: "Neutral 650", var: "--foundation-neutral-650" },
        { name: "Neutral 700", var: "--foundation-neutral-700" },
        { name: "Neutral 750", var: "--foundation-neutral-750" },
        { name: "Neutral 800", var: "--foundation-neutral-800" },
        { name: "Neutral 850", var: "--foundation-neutral-850" },
        { name: "Neutral 900", var: "--foundation-neutral-900" },
        { name: "Neutral 950", var: "--foundation-neutral-950" },
        { name: "Neutral 1000", var: "--foundation-neutral-1000" },
      ],
    },
    {
      title: "Brand",
      colors: [
        { name: "Brand 25", var: "--foundation-brand-25" },
        { name: "Brand 50", var: "--foundation-brand-50" },
        { name: "Brand 100", var: "--foundation-brand-100" },
        { name: "Brand 200", var: "--foundation-brand-200" },
        { name: "Brand 300", var: "--foundation-brand-300" },
        { name: "Brand 400", var: "--foundation-brand-400" },
        { name: "Brand 500", var: "--foundation-brand-500" },
        { name: "Brand 600", var: "--foundation-brand-600" },
        { name: "Brand 700", var: "--foundation-brand-700" },
        { name: "Brand 800", var: "--foundation-brand-800" },
        { name: "Brand 900", var: "--foundation-brand-900" },
      ],
    },
    {
      title: "Green",
      colors: Array.from({ length: 9 }, (_, i) => ({
        name: `Green ${(i + 1) * 100}`,
        var: `--foundation-green-${(i + 1) * 100}`,
      }))
        .concat([
          { name: "Green 25", var: "--foundation-green-25" },
          { name: "Green 50", var: "--foundation-green-50" },
        ])
        .sort((a, b) => {
          const aNum = parseInt(a.name.split(" ")[1]);
          const bNum = parseInt(b.name.split(" ")[1]);
          return aNum - bNum;
        }),
    },
    {
      title: "Teal",
      colors: Array.from({ length: 9 }, (_, i) => ({
        name: `Teal ${(i + 1) * 100}`,
        var: `--foundation-teal-${(i + 1) * 100}`,
      }))
        .concat([
          { name: "Teal 25", var: "--foundation-teal-25" },
          { name: "Teal 50", var: "--foundation-teal-50" },
        ])
        .sort((a, b) => {
          const aNum = parseInt(a.name.split(" ")[1]);
          const bNum = parseInt(b.name.split(" ")[1]);
          return aNum - bNum;
        }),
    },
    {
      title: "Blue",
      colors: Array.from({ length: 9 }, (_, i) => ({
        name: `Blue ${(i + 1) * 100}`,
        var: `--foundation-blue-${(i + 1) * 100}`,
      }))
        .concat([
          { name: "Blue 25", var: "--foundation-blue-25" },
          { name: "Blue 50", var: "--foundation-blue-50" },
        ])
        .sort((a, b) => {
          const aNum = parseInt(a.name.split(" ")[1]);
          const bNum = parseInt(b.name.split(" ")[1]);
          return aNum - bNum;
        }),
    },
    {
      title: "Purple",
      colors: Array.from({ length: 9 }, (_, i) => ({
        name: `Purple ${(i + 1) * 100}`,
        var: `--foundation-purple-${(i + 1) * 100}`,
      }))
        .concat([
          { name: "Purple 25", var: "--foundation-purple-25" },
          { name: "Purple 50", var: "--foundation-purple-50" },
        ])
        .sort((a, b) => {
          const aNum = parseInt(a.name.split(" ")[1]);
          const bNum = parseInt(b.name.split(" ")[1]);
          return aNum - bNum;
        }),
    },
    {
      title: "Violet",
      colors: Array.from({ length: 9 }, (_, i) => ({
        name: `Violet ${(i + 1) * 100}`,
        var: `--foundation-violet-${(i + 1) * 100}`,
      }))
        .concat([
          { name: "Violet 25", var: "--foundation-violet-25" },
          { name: "Violet 50", var: "--foundation-violet-50" },
        ])
        .sort((a, b) => {
          const aNum = parseInt(a.name.split(" ")[1]);
          const bNum = parseInt(b.name.split(" ")[1]);
          return aNum - bNum;
        }),
    },
    {
      title: "Fuschia",
      colors: Array.from({ length: 9 }, (_, i) => ({
        name: `Fuschia ${(i + 1) * 100}`,
        var: `--foundation-fuschia-${(i + 1) * 100}`,
      }))
        .concat([
          { name: "Fuschia 25", var: "--foundation-fuschia-25" },
          { name: "Fuschia 50", var: "--foundation-fuschia-50" },
        ])
        .sort((a, b) => {
          const aNum = parseInt(a.name.split(" ")[1]);
          const bNum = parseInt(b.name.split(" ")[1]);
          return aNum - bNum;
        }),
    },
    {
      title: "Red",
      colors: Array.from({ length: 9 }, (_, i) => ({
        name: `Red ${(i + 1) * 100}`,
        var: `--foundation-red-${(i + 1) * 100}`,
      }))
        .concat([
          { name: "Red 25", var: "--foundation-red-25" },
          { name: "Red 50", var: "--foundation-red-50" },
        ])
        .sort((a, b) => {
          const aNum = parseInt(a.name.split(" ")[1]);
          const bNum = parseInt(b.name.split(" ")[1]);
          return aNum - bNum;
        }),
    },
    {
      title: "Orange",
      colors: Array.from({ length: 9 }, (_, i) => ({
        name: `Orange ${(i + 1) * 100}`,
        var: `--foundation-orange-${(i + 1) * 100}`,
      }))
        .concat([
          { name: "Orange 25", var: "--foundation-orange-25" },
          { name: "Orange 50", var: "--foundation-orange-50" },
        ])
        .sort((a, b) => {
          const aNum = parseInt(a.name.split(" ")[1]);
          const bNum = parseInt(b.name.split(" ")[1]);
          return aNum - bNum;
        }),
    },
    {
      title: "Yellow",
      colors: Array.from({ length: 9 }, (_, i) => ({
        name: `Yellow ${(i + 1) * 100}`,
        var: `--foundation-yellow-${(i + 1) * 100}`,
      }))
        .concat([
          { name: "Yellow 25", var: "--foundation-yellow-25" },
          { name: "Yellow 50", var: "--foundation-yellow-50" },
        ])
        .sort((a, b) => {
          const aNum = parseInt(a.name.split(" ")[1]);
          const bNum = parseInt(b.name.split(" ")[1]);
          return aNum - bNum;
        }),
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.titleContainer}>
          <div className={styles.title}>Foundation Colors</div>
        </div>

        <div className={styles.sectionsGrid}>
          {colorSections.map((section) => (
            <section key={section.title} className={styles.section}>
              <div className={styles.sectionHeader}>
                <div className={styles.sectionTitle}>{section.title}</div>
              </div>
              <div className={styles.colorsGrid}>
                {section.colors.map((color) => (
                  <ColorSwatch
                    key={color.name}
                    name={color.name}
                    colorVar={color.var}
                  />
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
